import { IGetOrderSummaryModel } from 'models/GetOrderSummary.Model';
import React, { useEffect, useState } from 'react'
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { Card, CardBody, Col, Container, Row, Toast, ToastBody, ToastHeader } from 'reactstrap';
import CommonService from 'services/CommonService';
import Questionnaire from 'pages/NewRequote/Questionnaire';
import { getStatusIds } from '../../helpers/Helper';
import { HelperConstant } from '../../helpers/HelperConstant';

function Requote() {
    let navigate = useNavigate();
    const { encryptedId } = useParams<any>();
    const [searchParams] = useSearchParams();
    const [orderSummaryInfo, setOrderSummaryInfo] = useState<IGetOrderSummaryModel>();
    const [showError, setShowError] = useState<boolean>(false);
    let statsId = searchParams.get('dashboardStatusId');
    const pendingIds = `${HelperConstant.StatusId.PENDING},${HelperConstant.StatusId.PUBLICRECALCULATION},${HelperConstant.StatusId.ADMINCRECALCULATION}`;

    useEffect(() => {
        const GetOrderSummaryWithTemplate = () => {
            if (encryptedId) {
                CommonService.postWithSingleParam('sell', 'GetOrderSummaryWithTemplate', encryptedId).then((res: any) => {
                    setOrderSummaryInfo(res.data);
                }).catch(e => {
                    if (e == 'Request failed with status code 401') {
                        navigate('/logout')
                    } else {
                        console.error("API error:", e);
                    }
                })
            }
        }

        const GetEnquirySummaryWithTemplate = () => {
            if (encryptedId) {
                CommonService.postWithSingleParam('sell', 'GetEnquirySummaryWithTemplate', encryptedId).then((res: any) => {
                    setOrderSummaryInfo(res.data);
                })
            }
        }

        if (getStatusIds(parseInt(statsId ?? "")) == pendingIds) {
            GetEnquirySummaryWithTemplate();
        }
        else {
            GetOrderSummaryWithTemplate();
        }

    }, [encryptedId])

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <div>
                        <h5 className="d-flex mb-3 fw-semibold text-dofy dofy-admin-font-md" style={{ whiteSpace: "nowrap" }}>ORDER RE-QUOTE</h5>
                    </div>
                    {showError}
                    <div className="position-fixed top-0 end-0 p-3" style={{ zIndex: "1005" }}>
                        <Toast isOpen={showError}>
                            <ToastBody className='bg-warning-subtle'>
                                Select any options
                            </ToastBody>
                        </Toast>
                    </div>
                    <Card className='p-0'>
                        <CardBody style={{ padding: "15px" }}>
                            <div>
                                <span className='text-dofy font-size-14'>Order Id: </span>
                                <span className='text-dofy font-size-16 fw-semibold'>{orderSummaryInfo?.OrderCode}</span>
                            </div>
                            <Row>
                                <Col>
                                    <Questionnaire statsId={statsId} data={orderSummaryInfo} id={'0'} setShowError={setShowError} showError={showError} />
                                </Col>
                            </Row>
                        </CardBody>
                    </Card>
                </Container>
            </div>
        </React.Fragment>
    )
}

export default Requote
